import React, { useId, useState } from "react";
import PropTypes from "prop-types";
import { ChevronDown } from "lucide-react";

const AccordionItem = ({ anchorId, children, defaultOpen = false, description, disabled = false, headingLevel = 3, icon: Icon, title }) => {
  const [open, setOpen] = useState(defaultOpen);
  const generatedId = useId();
  const triggerId = `${generatedId}-trigger`;
  const panelId = `${generatedId}-panel`;
  const Heading = `h${headingLevel}`;

  return (
    <section className={["wsm-accordion__item", open && "wsm-accordion__item--open"].filter(Boolean).join(" ")} id={anchorId}>
      <Heading className="wsm-accordion__heading">
        <button aria-controls={panelId} aria-expanded={open} disabled={disabled} id={triggerId} onClick={() => setOpen((current) => !current)} type="button">
          {Icon && <span className="wsm-accordion__icon"><Icon aria-hidden="true" /></span>}
          <span className="wsm-accordion__title"><strong>{title}</strong>{description && <small>{description}</small>}</span>
          <ChevronDown aria-hidden="true" />
        </button>
      </Heading>
      <div aria-hidden={!open} aria-labelledby={triggerId} className="wsm-accordion__panel" id={panelId} inert={!open ? "" : undefined} role="region">
        <div className="wsm-accordion__panel-inner">{children}</div>
      </div>
    </section>
  );
};

AccordionItem.propTypes = {
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.bool,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  headingLevel: PropTypes.oneOf([2, 3, 4, 5, 6]),
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
};

const Accordion = ({ children, className = "" }) => <div className={["wsm-accordion", className].filter(Boolean).join(" ")}>{children}</div>;
Accordion.propTypes = { children: PropTypes.node.isRequired, className: PropTypes.string };
Accordion.Item = AccordionItem;

export { AccordionItem };
export default Accordion;
